import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import CheckBoxLine from 'components/common/check-box-list/CheckBoxLine';
import { FormComponentValueSelectable } from 'components/common/form/layout/control';
import CheckBoxHeader from 'components/common/check-box-list/CheckBoxHeader';
import useBundleTranslation from 'i18n';

function LineWrapper({
    value,
    handleCheckboxChange,
    index,
}: {
    value: FormComponentValueSelectable;
    handleCheckboxChange: (valueIndex: number, newStatus: boolean) => void;
    index: number;
}) {
    return useMemo(
        () => <CheckBoxLine value={value} onChange={(event) => handleCheckboxChange(index, event.target.checked)} />,
        [value.selected],
    );
}

export default function SimpleRender({
    listValues,
    filteredList,
    handleCheckboxChange,
    handleBulkChange,
    formComponentName,
    height,
}: {
    listValues: FormComponentValueSelectable[];
    filteredList: FormComponentValueSelectable[];
    handleCheckboxChange: (valueIndex: number, newStatus: boolean) => void;
    handleBulkChange: (newValue: boolean) => void;
    formComponentName: string;
    height: number;
}) {
    const { t } = useBundleTranslation(['components/common/check_box_list']);
    const [allVisibleIsChecked, setAllVisibleIsChecked] = useState<boolean>(false);
    const handleBulkChangeCheckBox = function () {
        handleBulkChange(!allVisibleIsChecked);
    };

    const newAllVisibleCheckValue = filteredList.filter((v) => v.selected).length == filteredList.length;
    useEffect(() => {
        if (newAllVisibleCheckValue !== allVisibleIsChecked) {
            setAllVisibleIsChecked(newAllVisibleCheckValue);
        }
    }, [filteredList, newAllVisibleCheckValue, allVisibleIsChecked]);

    return (
        <>
            <Box>
                <CheckBoxHeader
                    checked={allVisibleIsChecked}
                    name={formComponentName}
                    label={t('select_all')}
                    onChange={handleBulkChangeCheckBox}
                />
            </Box>
            <Box sx={{ height: height, overflowY: 'auto' }}>
                {filteredList.map((v) => {
                    const realIndex = listValues.findIndex((listValue) => listValue.value == v.value);
                    return (
                        <Box key={v.value}>
                            <LineWrapper value={v} index={realIndex} handleCheckboxChange={handleCheckboxChange} />
                        </Box>
                    );
                })}
            </Box>
        </>
    );
}
